const HOST_ID = "popup-preview-shadow-root";
const MAX_Z_INDEX = 2147483647;
const OVERLAY_STYLE_ID = "weupsell-hide-third-party-floaters";

/**
 * Third-party floaters (Smile.io Rewards, chat widgets, etc.) often use
 * z-index 2147483647 outside our shadow host. Same max z + later in DOM
 * paints above the cart drawer. Do NOT reparent #popup-preview-shadow-root
 * (that reloads shadow CSS). Hide known widgets while the drawer is open.
 */
const THIRD_PARTY_FLOATER_SELECTORS = [
  "#smile-ui-lite-container",
  "#smile-ui-lite-launcher-frame-container",
  "#smile-ui-container",
  "[id^='smile-ui']",
  "#gorgias-chat-container",
  "#gorgias-chat-messenger-container",
  "#intercom-container",
  ".intercom-lightweight-app",
  "#hubspot-messages-iframe-container",
];

function ensureOverlayHideStyles() {
  if (typeof document === "undefined") return null;
  let style = document.getElementById(OVERLAY_STYLE_ID);
  if (style) return style;

  const rules = THIRD_PARTY_FLOATER_SELECTORS.map(
    (selector) => `html.weupsell-static-cart-open ${selector}`
  ).join(",\n");

  style = document.createElement("style");
  style.id = OVERLAY_STYLE_ID;
  style.textContent = `
${rules} {
  visibility: hidden !important;
  pointer-events: none !important;
  opacity: 0 !important;
}
`;
  document.head.appendChild(style);
  return style;
}

/**
 * Keep the WeUpsell shadow host on top of the stacking context.
 *
 * Important: do NOT reparent with document.body.appendChild(host).
 * Moving the shadow host causes shadow stylesheets to reload for a few
 * frames/seconds — the cart drawer flashes unstyled on the left of the page.
 */
export function promoteWeupsellShadowHostStack() {
  if (typeof document === "undefined") return;

  const host = document.getElementById(HOST_ID);
  if (!host) return;

  host.style.zIndex = String(MAX_Z_INDEX);
  host.style.setProperty("display", "block", "important");
  if (!host.style.position) {
    host.style.position = "fixed";
  }
}

/**
 * Hide / restore third-party max-z floating widgets while cart drawer is open.
 */
export function setThirdPartyFloatersHiddenForCartDrawer(hidden) {
  if (typeof document === "undefined") return;
  ensureOverlayHideStyles();
  document.documentElement.classList.toggle("weupsell-static-cart-open", !!hidden);
}
